import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "src/config/config";
import { apiConstants } from "../constant/apiConstant";
import { Injectable } from "@angular/core";

@Injectable()
export class TransferCertificatePreviewServices {
    private API_V3_URL = AppSettings.API_ENDPOINT_V3;
    private getAllTcForParticularJobApiEndpoint = apiConstants.getAllTcForParticularJobApiEndpoint;
    private emailTcApiEndpoint = apiConstants.emailTcApiEndpoint;
    headers: HttpHeaders;

    constructor(private http: HttpClient) {
        const token = localStorage.getItem('usertoken');
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'token': token
        })
    }

    getAllTcForParticularServiceApi(jobDetailId) {
        return this.http.get(`${this.API_V3_URL}${this.getAllTcForParticularJobApiEndpoint}/?jobDetailId=${jobDetailId}&lang=en`,
            {
                headers: this.headers
            }
        ).pipe(map(res => res));
    }

    emailTransferCertificate(body: any) {
        return this.http.post(this.API_V3_URL + `${this.emailTcApiEndpoint}`,
            body,
            {
                headers: this.headers
            }
        ).pipe(map(res => res));
    }

}